import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 60 — "There's a real chance we don't see an iPhone 22."
 * Green-themed (matches the "future / possibility" framing in this section
 * — not red/yellow alarm).
 */

const GREEN = "#96C11F";
const AQUA = "#00deb6";

export default function Scene60_iPhone22() {
  return (
    <SceneShell variant="ink" align="left" data-testid="scene-iphone-22">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 75% 50%, rgba(150,193,31,0.14) 0%, transparent 55%)",
            "radial-gradient(ellipse at 75% 50%, rgba(0,222,182,0.22) 0%, transparent 55%)",
            "radial-gradient(ellipse at 75% 50%, rgba(150,193,31,0.14) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 11, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full">
        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-4xl sm:text-6xl lg:text-[88px] text-white leading-[1.0]"
          data-testid="iphone22-headline"
        >
          There's a real chance
          <br />
          we{" "}
          <span style={{ color: GREEN, fontWeight: 800 }}>don't see</span>{" "}
          an{" "}
          <span
            style={{
              background: `linear-gradient(135deg, ${GREEN} 0%, ${AQUA} 100%)`,
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              fontWeight: 900,
            }}
          >
            iPhone 22.
          </span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 2.2 }}
          className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl"
        >
          <Strike
            label="Not because"
            text="technology slows down."
          />
          <Lift label="But because" text="it moves on to something else entirely." />
        </motion.div>
      </div>
    </SceneShell>
  );
}

function Strike({ label, text }) {
  return (
    <div
      className="rounded-2xl p-5"
      style={{
        background: "rgba(150,193,31,0.04)",
        border: `1px solid ${GREEN}33`,
      }}
    >
      <div
        className="text-[10px] tracking-[0.32em] uppercase mb-2"
        style={{ color: "rgba(255,255,255,0.55)" }}
      >
        {label}
      </div>
      <div
        className="text-base sm:text-lg line-through"
        style={{
          color: "rgba(255,255,255,0.52)",
          textDecorationColor: `${GREEN}99`,
          textDecorationThickness: "2px",
        }}
      >
        {text}
      </div>
    </div>
  );
}

function Lift({ label, text }) {
  return (
    <div
      className="rounded-2xl p-5"
      style={{
        background: "rgba(150,193,31,0.10)",
        border: `1px solid ${GREEN}73`,
        boxShadow: `0 0 40px ${GREEN}2e`,
      }}
    >
      <div
        className="text-[10px] tracking-[0.32em] uppercase mb-2"
        style={{ color: GREEN }}
      >
        {label}
      </div>
      <div
        className="text-base sm:text-lg"
        style={{ color: "rgba(255,255,255,0.92)", fontWeight: 600 }}
      >
        {text}
      </div>
    </div>
  );
}
